import { TFilterType } from '@legacy/apis/types/filterListAPI';
import { Autocomplete } from '@legacy/components/mui-components';
import { DataAutomationId } from '@legacy/utils/ts-utils';

export interface IFilterSelectOnChangeEvent {
  label?: string;
  value: string;
}

export interface IFilterItemProperties<U>
  extends Partial<Omit<HTMLFormElement, 'contentEditable'>>,
    DataAutomationId {
  fieldLabel: string;
  filterId: string;
  options?: Array<IFilterSelectOnChangeEvent>;
  defaultValue?: U;
  hiddenLabel?: boolean;
  type?: TFilterType;
}

export type TFilterItemProperties = IFilterItemProperties<
  Array<IFilterSelectOnChangeEvent>
>;

const FilterInput = ({
  fieldLabel,
  filterId,
  addFilterItem,
  options = [],
  defaultValue,
  type,
  ...restProps
}: TFilterItemProperties) => (
  <Autocomplete
    fullWidth
    multiple={type === 'MultiSelectTypeSearch'}
    options={options}
    defaultValue={defaultValue}
    disableCloseOnSelect
    disablePortal
    componentsProps={{
      popper: {
        modifiers: [
          {
            // We add this to prevent the popper from hiding the "is" and "is not" radio buttons
            name: 'flip',
            enabled: false,
          },
        ],
      },
    }}
    {...restProps}
    data-automation-id={restProps['data-automation-id']}
  />
);

export default FilterInput;
